import { render } from "./menu-set.vue?vue&type=template&id=2c037f0d&scoped=true&ts=true"
import script from "./menu-set.vue?vue&type=script&lang=ts"
export * from "./menu-set.vue?vue&type=script&lang=ts"

import "./menu-set.vue?vue&type=style&index=0&id=2c037f0d&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c037f0d"]])

export default __exports__